var _rect, _path, _path2, _path3, _path4, _path5, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIncognito = function SvgIncognito(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 80,
    viewBox: "0 0 134 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "incognito_svg__mask0_9773_32927",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 134,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 134,
    height: 80,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#incognito_svg__mask0_9773_32927)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.4112 35.625H46.9626L52.7639 12.5L61.4086 15.4839L80.61 12.5L86.4112 35.625Z",
    fill: "#E9E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.687 51.4773C64.1562 51.4773 62.1046 53.6141 62.1046 56.25H59.4861C59.4861 52.1079 62.7101 48.75 66.687 48.75C70.664 48.75 73.888 52.1079 73.888 56.25H71.2694C71.2694 53.6141 69.2178 51.4773 66.687 51.4773Z",
    fill: "#E9E8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.687 33.125C87.573 33.125 103.318 41.25 103.318 41.25H30.0562C30.0562 41.25 45.801 33.125 66.687 33.125Z",
    fill: "url(#incognito_svg__paint0_linear_9773_32927)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "incognito_svg__mask1_9773_32927",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 44,
    width: 56,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6405 67.7936C57.0136 67.7936 62.1799 62.6369 62.1799 56.2757C62.1799 49.9145 57.0136 44.7578 50.6405 44.7578C44.2674 44.7578 39.1011 49.9145 39.1011 56.2757C39.1011 62.6369 44.2674 67.7936 50.6405 67.7936Z",
    fill: "url(#incognito_svg__paint1_linear_9773_32927)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9509 67.7936C89.324 67.7936 94.4903 62.6369 94.4903 56.2757C94.4903 49.9145 89.324 44.7578 82.9509 44.7578C76.5778 44.7578 71.4115 49.9145 71.4115 56.2757C71.4115 62.6369 76.5778 67.7936 82.9509 67.7936Z",
    fill: "url(#incognito_svg__paint2_linear_9773_32927)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#incognito_svg__mask1_9773_32927)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#incognito_svg__filter0_f_9773_32927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.76779 34.8402C7.02771 41.6871 6.3448 48.5563 5.57613 55.3921C4.87042 61.9077 7.93183 64.2181 18.2116 68.0423C41.8672 76.8082 65.486 86.2146 89.1238 95.4389C93.2117 97.0281 96.7271 96.3958 96.9729 94.0269C98.7207 77.18 100.47 60.3165 102.275 43.4917L7.76779 34.8402Z",
    fill: "#FFB9F8"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#incognito_svg__filter1_f_9773_32927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.9505 98.0176C51.9471 98.0186 51.9458 98.014 51.9489 98.0119C65.5277 88.6473 83.405 79.1533 103.605 70.7497C103.987 70.5909 104.369 70.4327 104.753 70.2748C110.668 67.8398 114.863 61.3189 114.349 55.0879C113.701 47.237 106.052 43.6909 98.9114 47.8911L58.819 71.4731C53.8073 74.421 50.6281 80.2975 51.0419 85.8196C51.3465 89.8835 51.6466 93.9485 51.9532 98.0136C51.9534 98.0153 51.9521 98.0171 51.9505 98.0176Z",
    fill: "#FFE665"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#incognito_svg__filter2_f_9773_32927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.873 70.5859C20.6714 76.2418 15.4655 81.8926 10.2567 87.5513C15.7896 84.3661 21.5279 80.4772 27.09 76.4313C32.0834 72.7967 37.1761 68.9268 41.9666 66.5963C46.0142 64.626 49.5551 63.8776 52.881 63.6374C58.9089 60.2729 64.481 58.3646 69.5346 58.0541C73.3124 57.8236 72.2295 60.0633 74.6022 61.6621C69.7261 64.5224 75.2085 65.9935 80.1069 63.3114C82.1131 62.2129 81.213 62.1096 83.1104 61.3843C84.4358 60.8824 85.9481 58.8225 87.0922 58.7089C92.309 58.2065 102.083 49.0685 106.857 49.3366C106.236 43.5158 91.4792 52.5893 88.1765 49.5033C76.7399 55.825 75.0357 52.9118 65.6148 54.0339C64.8395 54.125 62.9078 51.7247 62.1461 51.7863L35.1394 60.0137C33.5532 61.554 27.3753 68.9551 25.873 70.5859Z",
    fill: "#71BBFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#incognito_svg__filter3_f_9773_32927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9814 71.9116C56.7677 70.0704 72.3987 65.5453 79.1113 58.4023C74.5804 52.1509 68.4887 65.6314 63.9578 59.38L48.9946 63.6093C45.219 67.419 43.0393 66.4727 46.9814 71.9116Z",
    fill: "#0A9F68"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#incognito_svg__filter4_f_9773_32927)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0513 69.2811C17.9209 69.5253 17.9602 69.7964 17.8257 70.0526C17.6911 70.3088 17.3035 70.981 17.3594 71.1301C17.4402 71.3456 17.3436 71.7415 17.749 71.8317C18.1408 71.9188 18.6824 71.7215 19.0873 71.6115C20.5735 71.2077 21.9983 70.5435 23.4304 70.0208C24.1547 69.7564 24.9321 69.6453 25.6778 69.4077C26.0412 69.2919 26.2012 69.1108 26.6141 69.0576C27.0105 69.0065 27.3762 68.8663 27.751 68.7469C28.658 68.4578 29.5246 68.4381 30.4749 68.3431C31.524 68.2382 32.8758 67.6952 33.8222 67.3049C36.8463 66.0577 38.6486 63.867 40.9729 62.0325C41.8745 61.3209 42.5826 60.4942 43.5709 59.8398C44.6119 59.1504 45.8177 58.7567 47.0592 58.3609C49.1764 57.6861 51.5261 56.9984 53.4293 55.975C54.3113 55.5008 55.0681 54.9749 55.5326 54.2152C56.0333 53.3964 55.2993 52.0696 54.4394 51.5934C53.9619 51.329 52.867 51.3306 52.2651 51.3346C51.6267 51.3389 50.9914 51.4008 50.3563 51.4728C47.985 51.7417 45.6759 52.673 43.7362 53.795C41.3012 55.2037 38.7088 55.3931 35.9685 56.1218C34.6538 56.4714 33.4062 56.9577 32.1666 57.4311C31.3449 57.7449 30.7804 58.547 30.1815 59.05C28.4988 60.4636 27.6273 62.2352 25.6011 63.3999C24.6604 63.9407 23.6616 64.4618 22.588 64.819C22.0041 65.0133 21.1244 65.2866 20.691 65.6817C19.8853 66.4162 18.8351 67.2305 18.5417 68.173C18.4347 68.5167 18.2254 68.9551 18.0513 69.2811Z",
    fill: "#FFE665"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "incognito_svg__filter0_f_9773_32927",
    x: 1.47974,
    y: 30.8402,
    width: 104.795,
    height: 69.475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9773_32927"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "incognito_svg__filter1_f_9773_32927",
    x: 43.0059,
    y: 38.1074,
    width: 79.3857,
    height: 67.9103,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32927"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "incognito_svg__filter2_f_9773_32927",
    x: 2.25684,
    y: 39.3406,
    width: 112.6,
    height: 56.2108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32927"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "incognito_svg__filter3_f_9773_32927",
    x: 36.8904,
    y: 48.7034,
    width: 50.2209,
    height: 31.2083,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32927"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "incognito_svg__filter4_f_9773_32927",
    x: 9.354,
    y: 43.3337,
    width: 54.3416,
    height: 36.5195,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_9773_32927"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incognito_svg__paint0_linear_9773_32927",
    x1: 0.132371,
    y1: 43.3696,
    x2: 1.11434,
    y2: 27.6367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incognito_svg__paint1_linear_9773_32927",
    x1: 39.1011,
    y1: 67.7936,
    x2: 94.4597,
    y2: 44.6844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388649,
    stopColor: "#FFB9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741231,
    stopColor: "#FFE665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A9F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "incognito_svg__paint2_linear_9773_32927",
    x1: 39.1011,
    y1: 67.7936,
    x2: 94.4597,
    y2: 44.6844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.388649,
    stopColor: "#FFB9F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741231,
    stopColor: "#FFE665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A9F68"
  })))));
};
export default SvgIncognito;